import type { OpenRadioButtonGroupProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { ChangeEvent } from 'react'
import { InputFieldset } from '../inputFieldset'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'

function getRadioValue(v: string | number | null) {
  if (typeof v === 'string') return 'other'
  if (typeof v === 'number') return `index-${v}`
  return undefined
}

export default function OpenRadioButtonGroup(props: OpenRadioButtonGroupProps) {
  const {
    error,
    inputId,
    onChange,
    openLabel = 'Other',
    options,
    value
  } = props

  function handleChange(newValue: string) {
    if (newValue === 'other') {
      onChange('')
      return
    }

    if (!newValue.startsWith('index-')) return

    const parsedValue = Number.parseInt(newValue.slice(6), 10)

    onChange(parsedValue)
  }

  function handleOpenChange(event: ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value)
  }

  return (
    <InputFieldset {...props}>
      <RadioGroup
        name={inputId}
        onValueChange={handleChange}
        value={getRadioValue(value)}
      >
        {options.map(option => (
          <div className='flex items-center gap-3' key={option.value}>
            <RadioGroupItem
              id={`${inputId}-${option.value}`}
              aria-label={option.label}
              value={`index-${option.value}`}
            />
            <Label
              htmlFor={`${inputId}-${option.value}`}
              className='font-normal'
            >
              {option.label}
            </Label>
          </div>
        ))}
        <div className='flex items-center gap-3' key='other'>
          <RadioGroupItem
            id={`${inputId}-other`}
            aria-label={openLabel}
            value='other'
          />
          <Label htmlFor={`${inputId}-other`} className='font-normal'>
            {openLabel}
          </Label>
        </div>
      </RadioGroup>

      {typeof value === 'string' && (
        <Input
          aria-invalid={!!error}
          aria-label={openLabel}
          name={`${inputId}-open`}
          onChange={handleOpenChange}
          type='text'
          value={value}
        />
      )}
    </InputFieldset>
  )
}
